import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Container, Avatar, Alert, Stack, Grid, Link as MuiLink } from '@mui/material';
import { createUser } from '../../api/adminApi';
import { useNavigate, Link } from 'react-router-dom';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import { motion } from 'framer-motion';

const CreateUser = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', password: '', role: 'user' });
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.username || !form.password || !form.email) {
      setError('All fields are required.');
      return;
    }
    try {
      await createUser(form);
      setDialogOpen(true);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Failed to create user');
      }
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
      <Paper sx={{ p: 4, width: 400 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField label="Username" name="username" fullWidth margin="normal" value={form.username} onChange={handleChange} />
          <TextField label="Email" name="email" type="email" fullWidth margin="normal" value={form.email} onChange={handleChange} />
          <TextField label="Password" name="password" type="password" fullWidth margin="normal" value={form.password} onChange={handleChange} />
          <TextField select label="Role" name="role" fullWidth margin="normal" value={form.role} onChange={handleChange}>
            <MenuItem value="owner">Owner</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
          </TextField>
          {error && <Typography color="error" variant="body2">{error}</Typography>}
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>Create</Button>
        </Box>
        <Dialog open={dialogOpen} onClose={handleDialogClose}>
          <DialogTitle>User Created</DialogTitle>
          <DialogContent>
            Your account has been created successfully. You can now log in.
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} autoFocus>
              Go to Login
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
};

export default CreateUser; 